import React from 'react';

export default function EmptyState({
  icon = '📦',
  title = 'لا توجد بيانات',
  description = '',
  actionLabel = '',
  onAction,
  style = {},
}) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 'var(--sp-4xl) var(--sp-xl)',
      textAlign: 'center',
      ...style,
    }}>
      <div style={{
        fontSize: '48px', lineHeight: 1, marginBottom: 'var(--sp-lg)',
        opacity: 0.6,
      }}>
        {icon}
      </div>
      <h3 style={{
        fontSize: 'var(--font-size-lg)', color: 'var(--color-text)',
        margin: '0 0 var(--sp-sm) 0', fontWeight: '600',
      }}>
        {title}
      </h3>
      {description && (
        <p style={{
          fontSize: 'var(--font-size-base)', color: 'var(--color-text-secondary)',
          margin: '0 0 var(--sp-lg) 0', maxWidth: '360px',
        }}>
          {description}
        </p>
      )}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          style={{
            padding: '10px 24px', borderRadius: 'var(--radius-sm)', border: 'none',
            backgroundColor: 'var(--color-primary)', color: 'white',
            fontSize: 'var(--font-size-base)', fontWeight: '600', cursor: 'pointer',
          }}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
